import httpClient from "@/services/index";

// @ts-expect-error -- untyped module
const validatorUrl = import.meta.env.VITE_VALIDATOR_URL;

export type VerifyResponse = {
  mode: string;
  loginGroupId: string;
  groupId: string;
  username: string;
  memberId: string;
  careTeamName: string;
  id: string;
  route: string;
  redirectUrl: string;
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  sid: string;
  isEmbedded: boolean;
};

export type ValidateTokenResult =
  | { data: VerifyResponse; error: null }
  | {
      data: null;
      error: { status: string; statusCode: number; message: string };
    };

const validateToken = async (): Promise<ValidateTokenResult> => {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("redirectKey");
  const embedded = queryParams.get("embedded");

  return httpClient
    .get(`${validatorUrl}/user/verify`, {
      headers: {
        redirectKey: token,
        embedded: embedded ?? "false",
      },
    })
    .then((response) => ({
      data: response.data as VerifyResponse,
      error: null,
    }))
    .catch((error) => {
      console.error(
        "There was a problem with the fetch operation:",
        error.message,
      );
      return {
        data: null,
        error: {
          status: error.message,
          statusCode: error.status,
          message: error.response.data.message,
        },
      };
    });
};

export default validateToken;
